<template>
<div>
    <span class="float-right">{{moment(nippou.day, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日')}}</span>
    <b-row>
        <b-col md="8">
            <b-row>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">所属グループ</label>
                        <b-form-input type="text" class="bg-white" readonly v-model="nippou.user.group.name"></b-form-input>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">氏名</label>
                        <b-form-input type="text" class="bg-white" readonly v-model="nippou.user.name"></b-form-input>
                    </div>
                </div>
            </b-row>

            <b-row>
                <div class="col-md-12">

                </div>
            </b-row>
        </b-col>
    </b-row>
</div>
</template>

<script>
    import moment from 'moment'
    export default {
        data: function() {
            return {
                moment: moment,
                nippou: {
                    start_hour: 0,
                    end_hour: 0,
                    breaktime: 0,
                    day: '',
                    media: [],
                    user: {
                        name: null,
                        group: {
                            description: null
                        }
                    }
                },
                nippouItems: [],
                attachments: [],
                total_hours: 0.00,
                total_worked_hours: 0.00,
                file: {
                    deletingId : null,
                    deletedId : null,

                }
            }
        },
        props: {
            day: String
        },
        methods: {
            refresh: function () {
            },
            addNippouItem(nippouItem) {
                window.axios.post('/api/nippou/'+this.nippou.id+'/item', {work_content:nippouItem} )
                .then(( response ) => {
                    //
                }).catch((error) => {
                    console.log(error)
                }).then(()=>{
                    this.getNippouItems()
                });
            },
            updateNippouItem(nippouItem) {
                this.calculateHours();
                window.axios.put(
                    '/api/nippou/'+this.nippou.id+'/item/'+nippouItem.id,
                    {work_content:nippouItem}
                ).then(( response ) => {
                    //
                    console.log(response)
                }).catch((response) => {
                    console.log(response)
                }).then(()=>{
                    this.getNippouItems()
                });
            },
            calculateHours() {
                var total = 0
                this.nippouItems.forEach(item => {
                    total += parseFloat(item.time)
                });
                this.total_worked_hours = (total.toFixed(2))
            },
            calculateTotalHours() {
                var total = 0
                // console.log(this.nippou.end_hour)
                // console.log(this.nippou.start_hour)
                total = moment
                        .duration(moment(this.nippou.end_hour,'HH:mm:ss')
                        .diff(moment(this.nippou.start_hour,'HH:mm:ss'))
                        ).asHours()

                // console.log(total)

                this.total_hours = (total.toFixed(2)) - (+this.nippou.breaktime)
            },
            getNippou() {
                window.axios.get('/api/nippou/current').then(({ data }) => {
                    this.nippou = data.nippou
                    this.getNippouItems()
                    this.getAttachments()
                    this.calculateTotalHours()
                    // console.log(data)
                }).catch((error) => {
                    console.log(error)
                });
            },
            getNippouItems() {
                window.axios.get('/api/nippou/'+this.nippou.id+'/item').then(({ data }) => {
                    this.nippouItems = data.nippouItems
                    this.calculateHours()
                }).catch((error) => {
                    console.log(error)
                });
            },
            getAttachments() {
                window.axios.get('/api/nippou/'+this.nippou.id+'/attachments').then(({ data }) => {
                    this.attachments = data
                    // console.log(data)
                }).catch((error) => {
                    console.log(error)
                });
            },
            deleteAttachment(attachment) {
                if (!confirm('添付資料を削除しますか？')) return
                this.file.deletingId = attachment.id
                console.log('/api/nippou/'+this.nippou.id+'/attachment/'+attachment.id)
                window.axios.delete(
                    '/api/nippou/'+this.nippou.id+'/attachment/'+attachment.id
                ).then(({ data }) => {
                    console.log(data)
                    this.getAttachments()
                }).catch((error) => {
                    console.log(error)
                }).then(()=>{
                    this.file.deletedId = attachment.id
                    this.file.deletingId = null
                })
            }
        },
        created() {
            this.getNippou()
        }
    }
</script>
